// Components
import mapboxgl from 'mapbox-gl'
import { useEffect, useRef } from 'react'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
// Estils
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

const ControlGeocoder = ({ accessToken, handleClick, map, onClose }) => {
	const containerRef = useRef(null)

	useEffect(() => {
		if (!map || !containerRef.current) {
			return
		}

		const geocoder = new MapboxGeocoder({
			accessToken,
			mapboxgl,
			flyTo: false,
			marker: false,
			types: 'place',
			language: 'ca,es',
			countries: 'es',
		})

		geocoder.on('result', (e) => {
			const center = e?.result?.center

			if (map && center && center.length >= 2) {
				const [lng, lat] = center
				map.flyTo({
					center: [lng, lat],
					zoom: map.getZoom(),
				})
			}

			if (!handleClick) return

			if (!center || center.length < 2) return

			const [lng, lat] = center
			const point = map?.project?.([lng, lat])
			const features =
				map && point
					? map.queryRenderedFeatures(point, {
							layers: ['punts_habilitats', 'municipises'],
						})
					: []

			handleClick({
				lngLat: { lng, lat },
				point,
				features,
				target: map,
			})
		})
		geocoder.on('clear', () => {
			onClose?.()
		})

		containerRef.current.appendChild(geocoder.onAdd(map))

		return () => {
			geocoder.onRemove()
		}
	}, [accessToken, handleClick, map, onClose])

	return <div className='container-geocoder' ref={containerRef} />
}

export default ControlGeocoder
